import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/transparent-logo.png";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      minHeight="100vh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      bgcolor="#f8fafc"
      textAlign="center"
      px={2}
    >
      <img
        src={logo}
        alt="Application Logo"
        style={{ width: 150, height: 150, objectFit: "contain", marginBottom: 16 }}
      />
      <Typography variant="h1" color="primary" fontWeight={700} mb={2}>
        404
      </Typography>
      <Typography variant="h5" mb={2}>
        Page Not Found
      </Typography>
      <Typography variant="body1" color="text.secondary" mb={4}>
        Sorry, the page you are looking for does not exist.
      </Typography>
      <Button variant="contained" color="primary" onClick={() => navigate(-1)} startIcon={<ArrowBackIcon />}>
        Go Back
      </Button>
    </Box>
  );
};

export default NotFoundPage;